import { isValidElement, cloneElement, createElement } from 'react';
import { isReactComponent } from './is-react';
export function createContent(content, props) {
  if ( /*#__PURE__*/isValidElement(content)) {
    return props ? /*#__PURE__*/cloneElement(content, props) : content;
  }
  if (isReactComponent(content)) {
    return /*#__PURE__*/createElement(content, props);
  }
  return content;
}